export default "__VITE_ASSET__yHoTesvT__"